const LABELS = {
  observation: 'Observation',
  assignment: 'Assignment',
  assessment: 'Assessment',
};

export function dataPointTypeLabel(type) {
  return Object.prototype.hasOwnProperty.call(LABELS, type) ? LABELS[type] : 'Not specified';
}
